import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {PencilOutlineIcon} from 'shells/icon/svg/pencil-outline-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import type {NoOptionsMessageProps} from 'shells/select-picker-generic/select-picker-generic';
import {SelectTwoLineIcon} from 'shells/select-two-line-icon/select-two-line-icon';
import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

type Props = {
    options: TwoLineOptionWithIcon<any>[];
    value: TwoLineOptionWithIcon<any> | null | undefined;
    onChange: (value: TwoLineOptionWithIcon<any>) => void;
    placeholder: string;
    isLoading: boolean;
    shouldShowEditLink: boolean;
    editLink: string | null | undefined;
    editLabel: string;
    autoFocus: boolean;
    openMenuOnFocus: boolean;
    isSearchable: boolean;
    customNoOptionsMessage: NoOptionsMessageProps;
};

export const SelectTwoOptionEngagementEntity = (props: Props) => {
    return (
        <Stack spacing={8}>
            <SelectTwoLineIcon
                options={props.options}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
                isLoading={props.isLoading}
                customNoOptionsMessage={props.customNoOptionsMessage}
                autoFocus={props.autoFocus}
                openMenuOnFocus={props.openMenuOnFocus}
                isSearchable={props.isSearchable}
            />
            {props.shouldShowEditLink && props.editLink && (
                <div className='flex justify-end'>
                    <Link
                        // @ts-expect-error
                        as={RouterLink}
                        newTab={true}
                        variant='primary'
                        size='small'
                        icon={PencilOutlineIcon}
                        to={props.editLink}
                    >
                        {props.editLabel}
                    </Link>
                </div>
            )}
        </Stack>
    );
};
